import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/desc.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moJob from './store';
import moIndex from '../store/index';
import Table from './table';

interface IProps {}
interface IState {}

const Desc = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { list1, updateTime } = moJob;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="desc-1616">
      <p className="line-106106"><span>统计口径：</span><b>年总现金收入</b></p>
      <p className="line-106106"><span>地域：</span><b>一线城市</b></p>
      <p className="line-106106"><span>单位：</span><b>万元（人民币）</b></p>
      <p className="line-106106"><span>数据生效日期：</span><b>{updateTime}</b></p>
    </section>
  );
};

export default observer(Desc);
